import { theme } from "@chakra-ui/react"

export const fonts ={
    ...theme.fonts,
    // heading: "Larsseit, Inter, Helvetica Neue, Open Sans, sans-serif",
    // body: "Inter, Helvetica Neue, Open Sans, sans-serif",
    heading: `'Sora', sans-serif`,
    body: `'Inter', sans-serif`,
    cursive: `'Shantell Sans', sans-serif`,
  }